import { useState, useEffect, useCallback } from 'react';
import apiClient from '../../../../api/apiClient';

export interface Payroll {
  id: number;
  employee_id: number;
  period_month: number;
  period_year: number;
  month?: number; // Legacy field
  year?: number; // Legacy field
  base_salary: number | string | null;
  allowances: number | string | null;
  overtime_pay: number | string | null;
  overtime_hours: number | null;
  kpi_score: number | null;
  kpi_bonus: number | string | null;
  bonus: number | string | null;
  deductions: number | string | null;
  tax: number | string | null;
  bpjs_employee: number | string | null;
  bpjs_company: number | string | null;
  gross_salary: number | string | null;
  net_salary: number | string | null;
  status: string;
  approved_by?: string | null;
  approval_date?: string | null;
  payment_date?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface Employee {
  id: number;
  employee_id: string;
  full_name: string;
  position_id?: number | string | null;
  department_id?: number | null;
  [key: string]: any;
}

export interface Position {
  id: number;
  name: string;
  [key: string]: any;
}

export function usePayrollData(selectedMonth: number, selectedYear: number) {
  const [payrolls, setPayrolls] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [payrollResponse, empResponse, posResponse] = await Promise.all([
        apiClient.get('/hris/payroll', {
          params: { month: selectedMonth, year: selectedYear },
        }),
        apiClient.get('/hris/employees'),
        apiClient.get('/hris/positions'),
      ]);

      const payrollData = payrollResponse?.data || payrollResponse;
      const empData = empResponse?.employees || empResponse || [];
      const posData = posResponse?.positions || posResponse || [];

      setPayrolls(payrollData?.payrolls || []);
      setEmployees(Array.isArray(empData) ? empData : []);
      setPositions(Array.isArray(posData) ? posData : []);
    } catch (error) {
      console.error('Error loading data:', error);
      setPayrolls([]);
      setEmployees([]);
      setPositions([]);
    } finally {
      setLoading(false);
    }
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return {
    payrolls,
    employees,
    positions,
    loading,
    reload: loadData,
  };
}
